import React, { useEffect, useState } from "react";
import "./Login.css";
import { useAuth } from "./../../AuthProvider";
import { useNavigate, useLocation, Link } from "react-router-dom";
import LogoWithName from "../../assets/LogoName.svg";
import Loader from "../../Components/GlobalLoader/Loader";
import DOMPurify from 'dompurify';

const Login = () => {
  const navigate = useNavigate(); 
  const location = useLocation(); 
  const { login, isLoggingIn, user } = useAuth();
  const from = location.state?.from?.pathname || "/";
  const notice = location.state?.notice;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [usernameError, setUsernameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const loginType = "doctor";

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 7000); 

    window.addEventListener("beforeunload", () => {
      setLoading(true); 
    });

    return () => clearTimeout(timer);
  }, []);

  // const sanitizeInput = (input) => {
  //   return DOMPurify.sanitize(input);
  // };

  const onSubmit = async () => {
    setUsernameError(null);
    setPasswordError(null);
  
    const sanitizedUsername = DOMPurify.sanitize(username);
    const sanitizedPassword = DOMPurify.sanitize(password);
  
    if (!sanitizedUsername) {
      setUsernameError("Please enter your username");
      return;
    }
    if (!sanitizedPassword) {
      setPasswordError("Please enter your password");
      return;
    }
  
    try {
      setLoading(true);
      const result = await login(sanitizedUsername, sanitizedPassword, loginType);
      if (result?.requiresTerms) {
        navigate("/terms-of-use", {
          state: {
            pendingToken: result.pendingToken,
            contractUrl: result.contractUrl,
            contractVersion: result.contractVersion,
          },
        });
      } else {
        navigate("/");
      }
    } catch (error) {
      setPasswordError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="container">
      <div className="login_container">
        <div className="left_container-section">
          <h1></h1>
          <img src={LogoWithName} alt="logo" />
        </div>
        <div className="right_container-section">
          <h1 className="hello-agin">Doctor's Login</h1>
          {/* <div className="login-type-toggle">
            <button
              type="button"
              className={`login-type-option ${loginType === "doctor" ? "active" : ""}`}
              onClick={() => setLoginType("doctor")}
            >
              Doctor
            </button>
            <button
              type="button"
              className={`login-type-option ${loginType === "staff" ? "active" : ""}`}
              onClick={() => setLoginType("staff")}
            >
              Staff
            </button>
          </div> */}
          <p className="happy-text"></p>
          <div className="input-section">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="forgot-password">
            <div className="remember-checkbox">
              <input type="checkbox" />
              <span>Remember Me</span>
            </div>
            <Link to="/forgotpassword">Forgot Password?</Link>
          </div>
          <div className="error-container">
            {notice && <p className="notice-message">{notice}</p>}
            {usernameError && <p className="error-message">{usernameError}</p>}
            {passwordError && <p className="error-message">{passwordError}</p>}
          </div>
          <div className="login_footer">
            <button className="login-button" onClick={onSubmit}>
              {isLoggingIn ? (
                <div className="isLoader">
                  <Loader message="Please Wait" />
                </div>
              ) : (
                "Login"
              )}
            </button>
            {/* <p className="dont-have-account">
              Don't have an account? <Link to="/signUp">Sign Up</Link>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;